import { postalCodeConstants } from '../_constants';
import { postalCodeService } from '../_services';

export const postalCodeActions = {
    getAll,
    find,
};

function getAll() {
    return (dispatch) => {
        dispatch(request());

        postalCodeService.getAll()
            .then(
                postalCodes => dispatch(success(postalCodes)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: postalCodeConstants.GETALL_REQUEST };
    }
    function success(postalCodes) {
        return { type: postalCodeConstants.GETALL_SUCCESS, postalCodes };
    }
    function failure(error) {
        return { type: postalCodeConstants.GETALL_FAILURE, error };
    }
}

function find(value) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        postalCodeService.find(value)
            .then(
                (postalCode) => {
                    dispatch(success(postalCode));
                    resolve(postalCode);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: postalCodeConstants.FIND_REQUEST };
    }
    function success(postalCode) {
        return { type: postalCodeConstants.FIND_SUCCESS, postalCode };
    }
    function failure(error) {
        return { type: postalCodeConstants.FIND_FAILURE, error };
    }
}



// WEBPACK FOOTER //
// ./src/_actions/postalCode.actions.js